import { render, staticRenderFns } from "./BackofficeProcedimentoInternacaoAutorizarQuantidade.vue?vue&type=template&id=25c8e0df"
import script from "./BackofficeProcedimentoInternacaoAutorizarQuantidade.vue?vue&type=script&lang=ts"
export * from "./BackofficeProcedimentoInternacaoAutorizarQuantidade.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports